import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@auth';
import { of, switchMap } from 'rxjs';

export const isWelcomeCompletedGuard: CanActivateFn = (_: ActivatedRouteSnapshot) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return authStore.userProfile$.pipe(
    switchMap(profile => of(profile.firstLoginAt ? true : router.createUrlTree(['/welcome'])))
  );
};
